// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config from "../../../Config.bs.js";
import * as RnrUrl from "../domain/types/RnrUrl.bs.js";
import * as GAEvents from "../../../library/ga/GAEvents.bs.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CopyToClipboard from "./copy-clipboard/CopyToClipboard.bs.js";
import * as RewardMilestone from "../domain/types/RewardMilestone.bs.js";
import * as RnrAssetManager from "../assets/RnrAssetManager.bs.js";
import * as RnrParamsContext from "../utils/version/RnrParamsContext.bs.js";
import * as DateTime$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as VersionComparator from "../utils/version/VersionComparator.bs.js";
import * as UnorderedListComponent from "./UnorderedListComponent.bs.js";

var crossIcon = RnrAssetManager.getImage("right_arrow.svg");

var youtubeRedirectIcon = RnrAssetManager.getImage("coupon_youtube_icon.svg");

function redirectToLink(version, url) {
  if (VersionComparator.getIntegerFromAppVersion(version) >= VersionComparator.getAppLinkingMinVersion(undefined)) {
    PartnerAppInterface.launchExternalUrl(url);
  } else {
    window.open(url, "_parent");
  }
  
}

function handleRedemptionVideoClick(version, url, coupon_code) {
  GAEvents.publishEvent("rnr_award", "click_redemption_video", undefined, coupon_code, undefined, undefined);
  return redirectToLink(version, url);
}

function handleRedemptionLinkClick(version, url, coupon_code) {
  GAEvents.publishEvent("rnr_award", "click_redemption_link", undefined, coupon_code, undefined, undefined);
  return redirectToLink(version, url);
}

function getCouponDetails(title, scheme_details) {
  return React.createElement("div", {
              className: "coupon-details-container"
            }, React.createElement("div", {
                  className: "title"
                }, title), React.createElement(UnorderedListComponent.make, {
                  list: scheme_details
                }));
}

function getClaimLinks(version, claim_cta_content, coupon_code) {
  return React.createElement("div", {
              className: "claim-container"
            }, $$Array.of_list(List.map((function (claim_content) {
                        return React.createElement("div", {
                                    key: claim_content.name,
                                    className: "claim"
                                  }, React.createElement("div", {
                                        className: "title"
                                      }, claim_content.description), React.createElement("div", {
                                        className: "button",
                                        onClick: (function (_event) {
                                            return handleRedemptionLinkClick(version, RnrUrl.urltoString(claim_content.link), coupon_code);
                                          })
                                      }, React.createElement("div", {
                                            className: "text"
                                          }, claim_content.name)));
                      }), claim_cta_content)));
}

function renderVideoRedeem(version, videoLink, coupon_code) {
  return React.createElement("div", {
              className: "video-wrapper",
              onClick: (function (_event) {
                  return handleRedemptionVideoClick(version, videoLink, coupon_code);
                })
            }, React.createElement("img", {
                  className: "video-player",
                  src: youtubeRedirectIcon
                }));
}

function getRedeemSection(version, title, redemption_details, coupon_code) {
  var tmp;
  tmp = redemption_details.TAG === /* Text */0 ? React.createElement(UnorderedListComponent.make, {
          list: redemption_details._0
        }) : renderVideoRedeem(version, redemption_details._0, coupon_code);
  return React.createElement("div", {
              className: "redeem-container"
            }, React.createElement("div", {
                  className: "heading"
                }, title), tmp);
}

function getTitleSection(coupon_scheme) {
  return React.createElement("div", {
              className: "sponser-container"
            }, React.createElement("div", {
                  className: "icon-wrapper"
                }, React.createElement("img", {
                      className: "icon",
                      src: Belt_Option.mapWithDefault(coupon_scheme.rnr_sponsor.logo_url, "", (function (x) {
                              return x;
                            }))
                    })), React.createElement("div", {
                  className: "heading"
                }, React.createElement("div", {
                      className: "name"
                    }, coupon_scheme.rnr_sponsor.display_name), React.createElement("div", {
                      className: "title"
                    }, coupon_scheme.summary), React.createElement("div", {
                      className: "description"
                    }, coupon_scheme.short_description)));
}

function getCouponCodeSection(version, coupon_code, expiry_date, content) {
  return React.createElement("div", {
              className: "coupon-info-wrapper"
            }, React.createElement("div", {
                  className: "coupon-code-container"
                }, React.createElement("div", {
                      className: "coupon-text"
                    }, content.couponAward.couponText), React.createElement(CopyToClipboard.make, {
                      copyable_text: coupon_code,
                      modal_text: content.couponAward.codeAckTitle,
                      version: VersionComparator.getIntegerFromAppVersion(version)
                    })), React.createElement("div", {
                  className: "expiry-data"
                }, Curry._1(content.getExpiringDateTitle, DateTime$Catalyst.toString("Do MMM YYYY", expiry_date))));
}

function termsAndConditionsHandler(uuid, lang, auth_token, milestone) {
  window.open(Config.Env.getCrmBaseUrl(undefined) + ("/rnr/" + (uuid + ("/" + (RewardMilestone.toUrlString(milestone) + ("/tnc?auth_token=" + (auth_token + ("&lang=" + lang))))))), "_parent");
  
}

function RnrCouponAwardView(Props) {
  var content = Props.content;
  var coupon = Props.coupon;
  var milestone = Props.milestone;
  var rnrParams = RnrParamsContext.getRnrParams(undefined);
  return React.createElement("div", {
              className: "coupon-award-detail__container"
            }, getTitleSection(coupon.coupon_scheme), React.createElement("div", {
                  className: "separator"
                }), getCouponCodeSection(rnrParams.version, coupon.coupon_code, coupon.expiry_date, content), getCouponDetails(content.couponAward.detailsText, coupon.coupon_scheme.scheme_details), getClaimLinks(rnrParams.version, coupon.coupon_scheme.claim_cta_content, coupon.coupon_code), getRedeemSection(rnrParams.version, content.couponAward.redeemTitle, coupon.coupon_scheme.redemption_details, coupon.coupon_code), React.createElement("div", {
                  className: "separator"
                }), React.createElement("div", {
                  className: "terms-conditons",
                  onClick: (function (_event) {
                      return termsAndConditionsHandler(rnrParams.uuid, rnrParams.lang, rnrParams.auth_token, milestone);
                    })
                }, React.createElement("div", undefined, content.couponAward.tncText), React.createElement("img", {
                      className: "icon",
                      src: crossIcon
                    })));
}

var make = RnrCouponAwardView;

export {
  crossIcon ,
  youtubeRedirectIcon ,
  redirectToLink ,
  handleRedemptionVideoClick ,
  handleRedemptionLinkClick ,
  getCouponDetails ,
  getClaimLinks ,
  renderVideoRedeem ,
  getRedeemSection ,
  getTitleSection ,
  getCouponCodeSection ,
  termsAndConditionsHandler ,
  make ,
  
}
/* crossIcon Not a pure module */
